<template>
	<CommissionsReturnsTableReact :commissions="commissions" />
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { CommissionsReturnsTable } from "@/components/commissions/CommissionsReturnsTable";

const CommissionsReturnsTableReact = ReactInVue(CommissionsReturnsTable);

export default {
	name: "CommissionsReturnsTable",
	components: {
		CommissionsReturnsTableReact,
	},

	props: {
		commissions: {
			required: true,
			type: Array,
		},
	},
};
</script>

<style></style>
